import { useLocalNumbersStepsContext } from '../context/localNumbersStepsContext'
import { usePathSegment } from './usePathSegment'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useLocalNumbersStepsContext()

  return getProgressInfoTitle(usePathSegment())
}
